import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default {
	Vue,
	Vuex,
	/**
	 * 通过id获取对象的通用写法
	 * store:store本体
	 * targeter:存放数据的键值对对象,如state.keytobean,可以直接通过pkid获取指定对象的
	 * functionkey:如果数据字段不存在时应该调用的接口,也是store的接口,然后pkid会被传过去
	 */
	getBeanById: (store, targeter, functionkey,defaultValue) => {
		return pkid => {
			if(isempty(pkid)) {
				return defaultValue
			}
			if(targeter[pkid] == undefined) {
				//默认为空对象
				Vue.set(targeter, pkid, defaultValue)
				//获取数据
				store.commit(functionkey, pkid)
			}
			return targeter[pkid]
		}
	},
}